/*global GridController, WebView*/

var OAuthTokenEmbeddable = function(options){    
    GridController.call(this,"iz_oauth_token", 
    {
        directory: "views/user",
        name: "tokenGrid",
        searchRecords: {
            app_code: ["plugin_outlook"],
        },
        canCreate: false
    }) ;


    this.prepareDataOnEnter = function(data, callback){
        if(data){
            this.searchOptions.user_id = data.id ;
        }
        //call the normal function on the grid super class to continue with standard grid behavior
        GridController.prototype.prepareDataOnEnter.call(this, data, callback) ;
    } ;


    this.onEnable = function(ev){
        var token = ev.data.data ;
        this.view.longTask(function(done){
            this.api.db.iz_oauth_token.update({
                id: token.id,
                active: true
            }, function(err){
                if(err){ return done(err) ;}
                this.refresh(done) ;
            }.bind(this));
        }.bind(this));
    };

    this.onDisable = function(ev){
        var token = ev.data.data ;
        this.view.longTask(function(done){
            this.api.db.iz_oauth_token.update({
                id: token.id,
                active: false
            }, function(err){
                if(err){ return done(err) ;}
                this.refresh(done) ;
            }.bind(this));
        }.bind(this));
    };
    
    this.onRemove = function(ev){
        var token = ev.data.data ;
        this.view.confirm(WebView.tr("form.confirmDelete"), function(yes){
            if(yes){
                this.view.longTask(function(done){
                    this.api.db.iz_oauth_token.remove({
                        id: token.id,
                    }, function(err){
                        if(err){ return done(err) ;}
                        this.refresh(done) ;
                    }.bind(this));
                }.bind(this));
            }
        }.bind(this)) ;
    };
} ;

OAuthTokenEmbeddable.prototype = Object.create(GridController.prototype);
OAuthTokenEmbeddable.prototype.constructor = OAuthTokenEmbeddable;

module.exports = OAuthTokenEmbeddable ;